import _extends from "@babel/runtime-corejs3/helpers/extends";
import { onBeforeUpdate, onMounted, onUpdated, useInstance, findDomFromVNode, provide, inject, isComponentClass, isComponentFunction, hasVNodeChildren, hasMultipleChildren } from 'intact-vue-next';
import { useRecordParent, useRecordItem } from '../../hooks/useRecordComponent';
import { useKeyboard } from '../../hooks/useKeyboard';
import { useState } from '../../hooks/useState';
import { isComponentVNode } from '../utils';
import { DropdownItem } from './item';
// can not import DropdownMenu from index.ts, otherwise it will cause circle reference
// import {DropdownMenu} from './';
import { DropdownMenu } from './menu';
export var Direction;
(function (Direction) {
  Direction[Direction["Up"] = 0] = "Up";
  Direction[Direction["Down"] = 1] = "Down";
})(Direction || (Direction = {}));
var ITEM_EVENTS = 'ItemEvents';
var MENU_KEYBOARD = 'MenuKeyboard';
export function useMenuKeyboard() {
  var items = [];
  var itemEvents = useRecordParent(ITEM_EVENTS, true);
  var instance = useInstance();
  var focusIndex = -1;
  // we can't use the way that DropdownItem push itself to DropdownMenu to collect the items
  // because it can't guarantee the order
  function collect() {
    items.length = 0;
    var children = instance.$lastInput;
    var loop = function loop(vNode) {
      if (isComponentVNode(vNode, DropdownItem)) {
        items.push(vNode.children);
      } else {
        var _children = vNode.children;
        if (isComponentClass(vNode)) {
          var tag = vNode.tag;
          if (tag !== DropdownMenu && !(tag.prototype instanceof DropdownMenu)) {
            loop(_children.$lastInput);
          }
        } else if (isComponentFunction(vNode)) {
          loop(_children);
        } else if (hasVNodeChildren(vNode)) {
          loop(_children);
        } else if (hasMultipleChildren(vNode)) {
          _children.forEach(loop);
        }
      }
    };
    loop(children);
    return children;
  }
  onMounted(collect);
  var oldFocusIndex;
  onBeforeUpdate(function () {
    oldFocusIndex = focusIndex;
    reset();
  });
  onUpdated(function () {
    collect();
    if (oldFocusIndex < 0) return;
    focusByIndex(oldFocusIndex, Direction.Up);
  });
  function next(e) {
    e.preventDefault();
    focusByIndex(focusIndex + 1, Direction.Down);
  }
  function prev(e) {
    e.preventDefault();
    focusByIndex(focusIndex - 1, Direction.Up);
  }
  function focusByIndex(index, direction) {
    var max = items.length - 1;
    index = fixIndex(index, max);
    reset();
    var item = items[index];
    var i = 0;
    while (i <= max && item && item.get('disabled')) {
      index = fixIndex(direction === Direction.Down ? index + 1 : index - 1, max);
      item = items[index];
      i++;
    }
    // all items are disabled
    if (i > max) return;
    focusIndex = index;
    focusItem(item);
  }
  function focusItem(item) {
    itemEvents.get(item).onFocusin();
    var el = findDomFromVNode(item.$lastInput, true);
    var menuEl = findDomFromVNode(instance.$vNode, false);
    scrollToView(el, menuEl);
  }
  function reset() {
    var item = items[focusIndex];
    if (focusIndex > -1 && item) {
      itemEvents.get(item).onFocusout();
      focusIndex = -1;
    }
  }
  function makeEventCall(name) {
    return function (e) {
      if (focusIndex < 0) return;
      e.preventDefault();
      itemEvents.get(items[focusIndex])[name]();
    };
  }
  provide(MENU_KEYBOARD, {
    reset: reset,
    focus: function focus(item) {
      // reset();
      var index = items.indexOf(item);
      // if (index === -1) debugger
      focusIndex = index;
      focusItem(item);
    }
  });
  return [useKeyboard({
    down: next,
    up: prev,
    right: makeEventCall('onShowMenu'),
    left: makeEventCall('onHideMenu'),
    enter: makeEventCall('onSelect')
  }), focusByIndex, reset];
}
export function useItemKeyboard(itemEvents) {
  var isFocus = useState(false);
  var keyboard = inject(MENU_KEYBOARD);
  var instance = useInstance();
  useRecordItem(ITEM_EVENTS, instance, _extends({}, itemEvents, {
    onFocusin: function onFocusin() {
      isFocus.set(true);
    },
    onFocusout: function onFocusout() {
      isFocus.set(false);
    }
  }));
  return {
    onMouseEnter: function onMouseEnter(e) {
      instance.trigger('mouseenter', e);
      if (instance.get('disabled')) return;
      keyboard.focus(instance);
    },
    onMouseLeave: function onMouseLeave(e) {
      instance.trigger('mouseleave', e);
      keyboard.reset();
    },
    isFocus: isFocus
  };
}
function fixIndex(index, max) {
  if (index > max) {
    index = 0;
  } else if (index < 0) {
    index = max;
  }
  return index;
}
function scrollToView(el, menuEl) {
  var elRect = el.getBoundingClientRect();
  var pEl = getScrollParent(el.parentElement, menuEl);
  var pElRect = pEl.getBoundingClientRect();
  var bottomOverflowDistance = elRect.bottom - pElRect.bottom;
  var topOverflowDistance = elRect.top - pElRect.top;
  if (bottomOverflowDistance > 0) {
    pEl.scrollTop += bottomOverflowDistance;
  } else if (topOverflowDistance < 0) {
    pEl.scrollTop += topOverflowDistance;
  }
}
function getScrollParent(node, breakEl) {
  if (node === breakEl || node.scrollHeight > node.clientHeight) return node;
  return getScrollParent(node.parentElement, breakEl);
}